import React from 'react'
import { useNode } from '@craftjs/core'
import { FocusBoxSettings } from './FocusBoxSettings'

import { withBlock } from '../withBlock'
import { withCraft } from '../withCraft'

import { FocusBox as OriginalFocusBox } from 'react-components/molecules'

export const defaultProps = {}

export const dynamicProps = []

export const FocusBox = withBlock(
  props => {
    const blockProps = {
      ...defaultProps,
      ...props.block,
    }
    const { children } = props

    const _ = props.renderValue

    const {
      id,
      connectors: { connect, drag },
      selected,
      hovered,
      actions: { setProp, setCustom },
      customs,
    } = useNode(state => ({
      selected: state.events.selected,
      hovered: state.events.hovered,
      customs: state.data.custom,
    }))

    return (
      <div ref={ref => props.retRef(ref)} className={`block-wfocus-box ${props.className}`}>
        <OriginalFocusBox>{children?.props?.children}</OriginalFocusBox>
      </div>
    )
  },
  defaultProps,
  dynamicProps
)

FocusBox.craft = withCraft({
  name: 'FocusBox',
  defaultProps: defaultProps,
  settings: FocusBoxSettings,
})
